'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryCallingCode = exports.countrySelectOptions = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _TextField = require('./TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isempty');

var _lodash4 = _interopRequireDefault(_lodash3);

var _emojiFlags = require('emoji-flags');

var _emojiFlags2 = _interopRequireDefault(_emojiFlags);

var _countryTelephoneData = require('country-telephone-data');

var _libphonenumberJs = require('libphonenumber-js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buildCountrySelectOptions = function buildCountrySelectOptions(country) {
  var name = country.name,
      dialCode = country.dialCode,
      iso2 = country.iso2;
  // we only display the flag emojis for non-Windows operating systems because
  // Microsoft has chosen to limit support for flags.

  var isWindows = (0, _lodash2.default)(navigator, 'appVersion', '').indexOf('Win') !== -1;

  var _ref = _emojiFlags2.default.countryCode(iso2.toUpperCase()) || {},
      _ref$emoji = _ref.emoji,
      emoji = _ref$emoji === undefined ? '' : _ref$emoji;

  var label = (isWindows ? '' : emoji) + ' ' + name;
  if (dialCode) {
    label = label + ' (+' + dialCode + ')';
  }

  return {
    label: label.trim(),
    value: iso2
  };
};

var countrySelectOptions = exports.countrySelectOptions = _countryTelephoneData.allCountries.filter(function (country) {
  return Boolean(country.dialCode) && Boolean(country.iso2);
}).map(buildCountrySelectOptions);

var getCountryCallingCode = exports.getCountryCallingCode = function getCountryCallingCode(countryCode) {
  var _ref2 = _countryTelephoneData.allCountries.find(function (_ref3) {
    var iso2 = _ref3.iso2;
    return iso2 === countryCode;
  }) || {},
      dialCode = _ref2.dialCode;

  return dialCode ? '+' + dialCode : '';
};

var Phone = function (_Component) {
  _inherits(Phone, _Component);

  function Phone(props) {
    _classCallCheck(this, Phone);

    // Parse any initialValue we receive.
    var _this = _possibleConstructorReturn(this, (Phone.__proto__ || Object.getPrototypeOf(Phone)).call(this, props));

    var _this$parseInitialPho = _this.parseInitialPhoneNumber(_this.props.initialValue),
        _this$parseInitialPho2 = _this$parseInitialPho.country,
        country = _this$parseInitialPho2 === undefined ? '' : _this$parseInitialPho2,
        _this$parseInitialPho3 = _this$parseInitialPho.phone,
        phone = _this$parseInitialPho3 === undefined ? '' : _this$parseInitialPho3,
        _this$parseInitialPho4 = _this$parseInitialPho.ext,
        ext = _this$parseInitialPho4 === undefined ? '' : _this$parseInitialPho4;

    _this.state = {
      countryCode: country.toLowerCase(),
      minimumPhoneNumber: getCountryCallingCode(country.toLowerCase()) || '',
      phone: (0, _libphonenumberJs.formatNumber)(phone, country, 'International'),
      extension: ext
    };

    _this.onChangeCountryCode = _this.onChangeCountryCode.bind(_this);
    _this.onPhoneNumberChange = _this.onPhoneNumberChange.bind(_this);
    _this.onExtensionChange = _this.onExtensionChange.bind(_this);
    _this.onPhoneNumberKeyPress = _this.onPhoneNumberKeyPress.bind(_this);
    return _this;
  }

  // If the component is fed an intial value, the parent component may want to
  // treat the initial parsing of the phone number as a change event so it can
  // receive a properly formatted version of the number immediately.


  _createClass(Phone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _state = this.state,
          phone = _state.phone,
          extension = _state.extension;

      this.props.triggerChangeOnMount && this.onChange(phone, extension);
    }

    // NOTE: This is not a "controlled component" in React's eyes. It is up to us
    // to ensure that the cursor does not reset to the end of the phone text field
    // after each time we predictively format the number.

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.caretCorrection && this.caretCorrection();
      delete this.caretCorrection;
    }
  }, {
    key: 'parseInitialPhoneNumber',
    value: function parseInitialPhoneNumber(number) {
      if (!number) {
        return {};
      }

      // Assume a fallback country code of US in case the number isn't in
      // international format...because 'Murica? The output of parseNumber will be
      // an empty object if it fails due to an invalid phone number format.
      var parsedPhone = (0, _libphonenumberJs.parseNumber)(number, 'US', { extended: true });
      if (number && (0, _lodash4.default)(parsedPhone)) {
        parsedPhone = this.parseInvalidPhoneNumber(this.props.initialValue);
      }
      return parsedPhone;
    }
  }, {
    key: 'parseInvalidPhoneNumber',
    value: function parseInvalidPhoneNumber() {
      var invalidPhoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      // pick out phone and ext.
      var phoneParts = invalidPhoneNumber.split(/[A-Za-z]+/);
      var parsedPhone = {};

      if (phoneParts.length === 1) {
        // Option 1 - we only have digits
        parsedPhone = {
          phone: invalidPhoneNumber,
          country: '',
          ext: ''
        };
      } else if (phoneParts.length > 1) {
        // Option 2 - the phone number has both digits and alpha characters.
        // We can only do our best here. For now, assume the first segment of
        // digits is the phone number and the last segment of digits is an
        // extension.
        parsedPhone = {
          phone: phoneParts[0],
          country: '',
          ext: phoneParts[phoneParts.length - 1]
        };
      }

      return parsedPhone;
    }
  }, {
    key: 'onChangeCountryCode',
    value: function onChangeCountryCode(event) {
      var countryCode = (0, _lodash2.default)(event, 'value');
      if (!countryCode) {
        // Clearing the country code is equivalent to clearing the entire
        // component of its value. You can't have a telephone number without the
        // country code.
        this.setState({ countryCode: '', phone: '', extension: '' });
        this.props.onChange(undefined);
      } else {
        var countryCallingCode = getCountryCallingCode(countryCode);
        this.setState({
          countryCode: countryCode,
          minimumPhoneNumber: countryCallingCode,
          phone: new _libphonenumberJs.AsYouType().input(countryCallingCode),
          extension: ''
        });
        this.props.onChange({ number: countryCallingCode, isValid: false });
      }
    }

    // Remember whether this key press was delete (i.e. remove characters from
    // from left to right). This will prove to be useful when determining the new
    // position of the cursor/caret after the change has been processed.

  }, {
    key: 'onPhoneNumberKeyPress',
    value: function onPhoneNumberKeyPress(event) {
      this.wasDeletePressed = event.key === 'Delete';
    }

    // Callback for when the phone input field changes. Because the phone number
    // value is computed based on what the user enters, React will overwrite the
    // value each time and place the input caret/cursor at the end. This callback
    // manually resets the caret/cursor back to where the user previously had it.

  }, {
    key: 'onPhoneNumberChange',
    value: function onPhoneNumberChange(event) {
      var phone = (0, _lodash2.default)(event, 'target.value', '');
      var minimumPhoneNumber = this.state.minimumPhoneNumber;

      var newCaretLocation = void 0;

      // If the number doesn't start with the proper country code or if the
      // formatter results in empty string, reset the number because our user
      // is being silly.
      var shouldResetNumber = !phone.replace(/\s+/g, '').startsWith(minimumPhoneNumber) || !new _libphonenumberJs.AsYouType().input(phone);
      if (shouldResetNumber) {
        phone = new _libphonenumberJs.AsYouType().input(minimumPhoneNumber);
        newCaretLocation = phone.length;
      } else {
        var caretLocation = (0, _lodash2.default)(event, 'target.selectionStart', 0);
        var digitsBeforeCaret = this.getDigitsBeforeCaret(caretLocation, phone);

        // Update the phone number's formatting and then determine the new
        // caret location.
        phone = new _libphonenumberJs.AsYouType().input(phone);
        newCaretLocation = this.getNewCaretLocation(digitsBeforeCaret, phone);
      }

      // Configure a caret correction "callback" for running after the component
      // has been rerendered.
      var target = event.target;

      this.caretCorrection = function () {
        target.setSelectionRange(newCaretLocation, newCaretLocation);
      };

      this.onChange(phone, this.state.extension);
    }

    // Determines the number of digits before the caret/cursor

  }, {
    key: 'getDigitsBeforeCaret',
    value: function getDigitsBeforeCaret(caretLocation, phone) {
      var characters = phone.split('');
      var digitsBeforeCaret = 0;
      for (var i = 0; i < caretLocation; i++) {
        if (characters[i].match(/\d|\+/)) {
          digitsBeforeCaret++;
        }
      }
      return digitsBeforeCaret;
    }

    // Determines the new location of the caret/cursor by ensuring
    // the proper number of digits still preceed it.

  }, {
    key: 'getNewCaretLocation',
    value: function getNewCaretLocation(digitsBeforeCaret, phone) {
      var digitsSeen = 0;
      var caretPosition = 0;
      var characters = phone.split('');

      for (var i = 0; i < characters.length; i++) {
        if (characters[i].match(/\d|\+/)) {
          digitsSeen++;
          if (digitsSeen === digitsBeforeCaret) {
            caretPosition = i + 1; // place the caret immediately after
            break;
          }
        }
      }

      // If the user had pressed the Delete key (i.e. removing digits from
      // left to right), we should place the cursor after any trailing white
      // space to make the delete experience feel more natural.
      if (this.wasDeletePressed && characters[caretPosition] === ' ') {
        caretPosition++;
      }

      return caretPosition;
    }
  }, {
    key: 'onExtensionChange',
    value: function onExtensionChange(event) {
      var extension = (0, _lodash2.default)(event, 'target.value', '');
      // remove any non numeric characters from the extension
      extension = extension.replace(/\D/g, '');
      this.onChange(this.state.phone, extension);
    }
  }, {
    key: 'onChange',
    value: function onChange(phone, extension) {
      // build an E.123 formatted number with the extension
      var formattedNumber = extension ? phone + ' ext. ' + extension : phone;
      this.setState({ phone: phone, extension: extension });

      var payload = void 0;
      if (formattedNumber) {
        payload = {
          number: formattedNumber,
          isValid: (0, _libphonenumberJs.isValidNumber)(formattedNumber)
        };
      }

      this.props.onChange(payload);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disableBsStyling = _props.disableBsStyling,
          className = _props.className,
          countrySelectLabel = _props.countrySelectLabel,
          countrySelectClassName = _props.countrySelectClassName,
          countrySelectMenuStyle = _props.countrySelectMenuStyle,
          phoneTextInputLabel = _props.phoneTextInputLabel,
          phoneTextInputClassName = _props.phoneTextInputClassName,
          extensionTextInputLabel = _props.extensionTextInputLabel,
          extensionTextInputClassName = _props.extensionTextInputClassName;
      var _state2 = this.state,
          countryCode = _state2.countryCode,
          phone = _state2.phone,
          extension = _state2.extension;


      return _react2.default.createElement(
        'div',
        { className: ('phone ' + className).trim() },
        _react2.default.createElement(_Select2.default, {
          name: 'country',
          value: countryCode,
          onChange: this.onChangeCountryCode,
          options: countrySelectOptions,
          label: countrySelectLabel,
          className: ('phone-country ' + countrySelectClassName).trim(),
          menuContainerStyle: countrySelectMenuStyle
        }),
        _react2.default.createElement(_TextField2.default, {
          name: 'phone',
          label: phoneTextInputLabel,
          value: phone,
          onChange: this.onPhoneNumberChange,
          onFocus: function onFocus(e) {
            return e.target.setSelectionRange(phone.length, phone.length);
          },
          onKeyDown: this.onPhoneNumberKeyPress,
          type: 'tel',
          className: ('phone-number ' + phoneTextInputClassName).trim(),
          disabled: !countryCode,
          bsStyle: !disableBsStyling && countryCode && !(0, _libphonenumberJs.isValidNumber)(phone) ? 'error' : ''
        }),
        _react2.default.createElement(_TextField2.default, {
          name: 'extension',
          label: extensionTextInputLabel,
          value: extension,
          onChange: this.onExtensionChange,
          type: 'tel',
          className: ('phone-extension ' + extensionTextInputClassName).trim(),
          disabled: !countryCode
        })
      );
    }
  }]);

  return Phone;
}(_react.Component);

exports.default = Phone;


Phone.propTypes = {
  initialValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  triggerChangeOnMount: _propTypes2.default.bool,
  disableBsStyling: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  countrySelectLabel: _propTypes2.default.node,
  countrySelectClassName: _propTypes2.default.string,
  countrySelectMenuStyle: _propTypes2.default.object,
  phoneTextInputLabel: _propTypes2.default.node,
  phoneTextInputClassName: _propTypes2.default.string,
  extensionTextInputLabel: _propTypes2.default.node,
  extensionTextInputClassName: _propTypes2.default.string
};

Phone.defaultProps = {
  initialValue: '',
  triggerChangeOnMount: false,
  disableBsStyling: false,
  className: '',
  countrySelectLabel: 'Country Code...',
  countrySelectClassName: '',
  countrySelectMenuStyle: {},
  phoneTextInputLabel: 'Telephone (Allowed characters: 0-9)',
  phoneTextInputClassName: '',
  extensionTextInputLabel: 'Ext.',
  extensionTextInputClassName: ''
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/Phone.js
// module id = 456
// module chunks = 0